/**
 * 手机软键盘弹出 / 收起时 (visualViewport resize) 把聊天区滚到底部,
 * 避免输入框把最新消息挡住。对齐旧版 index.html 的 resize 处理。
 */
import { useEffect, type RefObject } from "react";

export function useScrollOnViewportResize(ref: RefObject<HTMLElement>) {
  useEffect(() => {
    const target: EventTarget | undefined =
      typeof window === "undefined" ? undefined : (window.visualViewport ?? window);
    if (!target) return;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const onResize = () => {
      clearTimeout(timer);
      // 等键盘动画结束再滚 (旧版同样延迟 300ms)
      timer = setTimeout(() => {
        const el = ref.current;
        if (el) el.scrollTop = el.scrollHeight;
      }, 300);
    };
    target.addEventListener("resize", onResize);
    return () => {
      clearTimeout(timer);
      target.removeEventListener("resize", onResize);
    };
  }, [ref]);
}
